import { useContext } from "react";
import { SnackbarContext } from "../context/snackbar.context";

const useSnackbar = () => useContext(SnackbarContext);

export default useSnackbar;
